import script from "./Videos.vue?vue&type=script&setup=true&lang=js"
export * from "./Videos.vue?vue&type=script&setup=true&lang=js"

import "./Videos.vue?vue&type=style&index=0&id=57ad99fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57ad99fe"]])

export default __exports__